import React from 'react'
import styled from 'styled-components'
import Comment from '../iconsV2/Comment'
import Delivery from '../iconsV2/Delivery'
import Disposal from '../iconsV2/Disposal'
import StockCount from '../iconsV2/StockCount'
import Administration from '../iconsV2/Administration'
import { Text } from '@lmc/ui-kit/src/general'

export type ActionType =
  | 'stock-count'
  | 'disposal'
  | 'delivery'
  | 'administration'
  | 'comment'

interface ActionCellProps {
  type: ActionType
  title: string
  subtitle: string
  hasDiscrepancy?: boolean
  onClick?: () => void
}

const renderActionIcon = (type: ActionType) => {
  switch (type) {
    case 'stock-count':
      return <StockCount />
    case 'disposal':
      return <Disposal />
    case 'delivery':
      return <Delivery />
    case 'administration':
      return <Administration />
    case 'comment':
      return <Comment />
    default:
      return <StockCount />
  }
}

const ActionCell: React.FC<ActionCellProps> = ({
  type,
  title,
  subtitle,
  hasDiscrepancy = false,
  onClick
}) => {
  const isClickable = type === 'administration' || type === 'comment'

  return (
    <ActionCellContainer
      onClick={isClickable ? onClick : undefined}
      $isClickable={true}
    >
      <IconContainer>{renderActionIcon(type)}</IconContainer>
      <TextContainer>
        <Title>{title}</Title>
        <Subtitle level={2}>{subtitle}</Subtitle>
      </TextContainer>
    </ActionCellContainer>
  )
}

const ActionCellContainer = styled.div<{ $isClickable: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0; // Allows text to truncate
`

const Title = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  line-height: 1;
`

const Subtitle = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export default ActionCell
